import AccordionTableRow from "./AccordionTableRow";
import { PaginateResult } from "core/resources/types/shared";
import { Flex, Box } from "@chakra-ui/layout";
import { Menu, MenuButton, MenuItem, MenuList } from "@chakra-ui/menu";
import useSelectableColumnAccordion from "./useSelectableColumnAccordion";
import { useTable, useSortBy, Column } from "react-table";
import { Button } from "@chakra-ui/button";
import { GoKebabVertical } from "react-icons/go";
import { Empty, Skeleton } from "antd";

function AccordionTable<T = any>({
  columnsAccordion,
  columnsInnerTable,
  loading,
  actions,
  enableSelected,
  onSelected,
  dataAccordion,
}: {
  children?: React.ReactChild[];
  styles?: object;
  columnsAccordion: Column[];
  columnsInnerTable: Column[];
  dataAccordion?: PaginateResult<T> | any[] | any;
  dataInnerAccordion?: PaginateResult<T> | any[] | any;
  header?: any;
  loading?: boolean;
  onChangePage?: Function;
  onClickRow?: (item: T) => void;
  actions?: { title: string; onClick: (item: T) => any }[];
  enableSelected?: boolean;
  onSelected?: (items: any[]) => void;
}) {
  const { column: selectableColumn } = useSelectableColumnAccordion<any>(
    dataAccordion.items,
    onSelected
  );

  let _columns: Column[] = [];
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable(
      {
        columns: columnsAccordion,
        data: dataAccordion,
      },
      useSortBy
    );

  if (actions?.length) {
    _columns = [
      enableSelected ? selectableColumn : undefined,
      ...columnsInnerTable,
      {
        Header: "",
        accessor: "menu",
        width: 80,
        maxWidth: 80,
        minWidth: 80,
        disableClick: true,
        Cell: ({ row: { original } }: { row: { original: T } }) => {
          return (
            <Flex justifyContent="flex-end">
              <Menu>
                <MenuButton>
                  <Button variant="outline" rounded="full" w="40px" h="40px">
                    <GoKebabVertical />
                  </Button>
                </MenuButton>
                <MenuList>
                  {actions.map((action, index) => (
                    <MenuItem
                      key={index}
                      fontSize="14px"
                      onClick={() => action.onClick(original)}
                    >
                      {action.title}
                    </MenuItem>
                  ))}
                </MenuList>
              </Menu>
            </Flex>
          );
        },
      } as any,
    ].filter((item: any) => item);
  } else {
    _columns = (
      [
        enableSelected ? selectableColumn : undefined,
        ...columnsInnerTable,
      ] as any
    ).filter((item: any) => item);
  }

  // We don't want to render all 2000 rows for this example, so cap
  // it at 20 for this use case
  const firstPageRows = rows.slice(0, 20);

  return (
    <table {...getTableProps()} width="100%">
      <thead
        style={{ display: "flex", width: "100%", justifyContent: "center" }}
      >
        {headerGroups.map((headerGroup) => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map((column: any) => {
              return (
                <th
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                  style={{ width: column.width ?? undefined }}
                >
                  {/* Render the columns filter UI */}
                  {column.render("Header")}
                  <span>
                    {column.isSorted
                      ? column.isSortedDesc
                        ? " 🔽"
                        : " 🔼"
                      : ""}
                  </span>
                </th>
              );
            })}
          </tr>
        ))}
      </thead>
      <tbody {...getTableBodyProps()}>
        {loading ? (
          <Box p="16px">
            <Skeleton active />
          </Box>
        ) : (
          <>
            {dataAccordion?.length ? (
              <>
                {firstPageRows.map((row, i) => {
                  prepareRow(row);
                  return (
                    <AccordionTableRow
                      dataAcordo={dataAccordion[i]}
                      row={row}
                      index={i}
                      columnsInnerTable={_columns}
                    />
                  );
                })}
              </>
            ) : (
              <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
            )}
          </>
        )}
      </tbody>
    </table>
  );
}

export default AccordionTable;
